
export const navigation = {
  home: "Home",
  services: "Services", 
  about: "About Us",
  benefits: "Why Us?",
  contact: "Contact"
};

export const hero = {
  title: "Transform Your",
  titleHighlight: "Digital Vision",
  titleEnd: "into Reality",
  subtitle: "Comprehensive technology solutions to drive your business towards the digital future",
  ctaPrimary: "Discover Our Services",
  ctaSecondary: "Request Free Consultation"
};

export const stats = {
  projects: "New",
  projectsLabel: "Innovative Projects",
  commitment: "100%",
  commitmentLabel: "Commitment", 
  experience: "5+",
  experienceLabel: "Years of Experience",
  support: "24/7",
  supportLabel: "Technical Support"
};

export const services = {
  title: "Our Services",
  subtitle: "We offer complete technology solutions to take your business to the next level",
  consultoria: {
    title: "Consulting Services",
    description: "Strategic advisory to optimize your business and technology processes.",
    features: ["Process Analysis", "Digital Strategy", "Operational Optimization"]
  },
  marketing: {
    title: "Digital Marketing", 
    description: "Comprehensive strategies to position your brand in the digital world.",
    features: ["SEO/SEM", "Content Marketing", "Email Marketing"]
  },
  eventos: {
    title: "Event Organization",
    description: "Planning and execution of memorable corporate events.",
    features: ["Corporate Events", "Conferences", "Product Launches"]
  },
  publicidad: {
    title: "Advertising",
    description: "Effective advertising campaigns across multiple platforms.",
    features: ["Google Ads", "Facebook Ads", "Display Marketing"]
  },
  redes: {
    title: "Social Media",
    description: "Professional management of your social media presence.",
    features: ["Community Management", "Content Creation", "Social Analytics"]
  },
  desarrollo: {
    title: "Web Development & APIs",
    description: "Development of modern web solutions and robust APIs.",
    features: ["Web Development", "REST APIs", "Integrations"]
  },
  web3: {
    title: "WEB3 Technologies",
    description: "Implementation of blockchain solutions and decentralized technologies.",
    features: ["Smart Contracts", "DApps", "NFT Platforms"]
  },
  ecommerce: {
    title: "E-commerce & Online Stores",
    description: "Complete solutions for your online business.",
    features: ["Online Stores", "Payment Gateways", "Inventory Management"]
  },
  viewMore: "View more details",
  hideDetails: "Hide details",
  includes: "Includes:"
};

export const about = {
  title: "Who are we?",
  description: "We are GlobalTechWay, a new and ambitious LLC specialized in digital transformation. Although we are a new company, our team has over 5 years of combined experience in technology and business consulting.",
  experiencedTeam: "Experienced Team",
  experiencedTeamDesc: "Professionals with experience in the best technology companies",
  cuttingEdgeTech: "Cutting-edge Technology", 
  cuttingEdgeTechDesc: "We use the latest technologies including Web3 and blockchain",
  personalizedApproach: "Personalized Approach",
  personalizedApproachDesc: "Each project is unique and deserves specialized attention"
};

export const benefits = {
  title: "Why choose GlobalTechWay?",
  subtitle: "As a new company, we are committed to offering the best quality and personalized attention",
  innovation: {
    title: "Constant Innovation",
    description: "We use the latest technologies and methodologies to drive your business towards the digital future."
  },
  team: {
    title: "Specialized Team", 
    description: "Expert professionals in each technology area ready to transform your ideas into reality."
  },
  quality: {
    title: "Guaranteed Quality",
    description: "Committed to excellence in every project, ensuring results that exceed expectations."
  },
  attention: {
    title: "Personalized Attention",
    description: "Each client is unique. We adapt our solutions to your specific needs."
  }
};

export const cta = {
  title: "Ready to be our next successful project?",
  subtitle: "As a new company, we are excited to work with you and create something incredible together",
  button: "Request Free Consultation"
};

export const contact = {
  title: "Contact Us",
  subtitle: "We are here to help you achieve your digital goals",
  email: "Email",
  phone: "Phone", 
  schedule: "Business Hours",
  scheduleWeekdays: "Monday - Friday: 10:00 AM - 6:00 PM",
  scheduleWeekend: ".",
  form: {
    name: "Name",
    nameRequired: "Name *",
    namePlaceholder: "Your full name",
    email: "Email",
    emailRequired: "Email *", 
    emailPlaceholder: "your@email.com",
    company: "Company",
    companyPlaceholder: "Your company name",
    service: "Service of Interest",
    serviceRequired: "Service of Interest *",
    servicePlaceholder: "Select a service",
    message: "Message",
    messageRequired: "Message *",
    messagePlaceholder: "Tell us about your project and how we can help you...",
    maxChars: "Maximum 500 characters",
    submit: "Send Message",
    services: {
      consultoria: "Consulting Services",
      marketing: "Digital Marketing", 
      eventos: "Event Organization",
      publicidad: "Advertising",
      redes: "Social Media",
      desarrollo: "Web Development & APIs",
      web3: "WEB3 Technologies",
      ecommerce: "E-commerce & Online Stores"
    }
  }
};

export const footer = {
  description: "We transform your digital vision into reality with innovative technology solutions and specialized consulting services.",
  services: "Services",
  quickLinks: "Quick Links",
  consulting: "Consulting",
  digitalMarketing: "Digital Marketing", 
  webDevelopment: "Web Development",
  ecommerce: "E-commerce",
  web3: "WEB3",
  home: "Home",
  about: "About Us", 
  whyUs: "Why Us?",
  contact: "Contact",
  madeWith: "Made with Readdy",
  copyright: "© 2025 GlobalTechWay LLC. All rights reserved."
};

export const common = {
  language: "Español"
};

export default {
  navigation,
  hero,
  stats,
  services,
  about,
  benefits,
  cta,
  contact,
  footer,
  common
};
